import React, {Component} from 'react'
import {Card, CardBody, Media, Row, Col, Collapse, CardHead, CardTitle, Badge, Button} from 'reactstrap';
import StdTable from '../StdTable'
import Accounts from '../Accounts'
import Assesments from '../Assesments'
import {find_evaluation} from '../../config/evaluations'
import {Activity, CreditCard, ChevronDown, ChevronUp} from 'react-feather';
import { Trans } from "react-i18next";
import StdButton from '../StdButton'
class Report extends Component{

  constructor(props){
	  super(props);
	  this.state = {isOpen: false}
  }

  
  render(){

	  const {report, updateReport} = this.props
	  const {isOpen} = this.state

	  const toSemaphore = shareholder => {
	    const semaphore = shareholder.semaphore != null && find_evaluation({semaphore: shareholder.semaphore}) ? <i className="fa fa-circle" style={{color: find_evaluation({semaphore: shareholder.semaphore}).color}}></i> : '-'
	    return {...shareholder, ...{semaphore: semaphore}}
	  }
	  
	  if(report)
	    return (
		    
		    <Card className="card_collapse page-break-before report" >
		      
		      <CardTitle>
			      <button onClick={() => this.setState({isOpen: !isOpen}) } className="content_button">
			        <Row>
				        <Col >
				          <h2>Report: <Trans>products.{report.product.name}</Trans></h2>
				        </Col>

				        <Col xs="auto">
				          
				          <Badge color="success" pill><small><Trans>reports.updated_at</Trans>: <b><Trans values={{value: report.updated_at}}>standard_formatting.date</Trans></b></small></Badge>&nbsp;
		    <Badge color="primary" pill><small><Trans>reports.created_at</Trans>: <b><Trans values={{value: report.created_at}}>standard_formatting.date</Trans></b></small></Badge>				
		    {isOpen ? <ChevronUp /> : <ChevronDown />}
				        </Col>
			        </Row>
			        
			      </button>
			      {  report.updates && report.updates.length > 0 && ['SPEEK_FLASH', 'CREDITSAFE'].includes(report.product.name) && <Badge color="warning"  style={{width: '100%', textAlign: 'left'}}><small><Trans>reports.updates</Trans>: {report.updates.map(u => <React.Fragment key={u}><Trans >{`reports.update_types.${u}`}</Trans>&nbsp;</React.Fragment>)}</small>
			      <StdButton buttonProps={{className:"btn btn-primary btn-low pull-right no-print"}}  confirmation={report.product.price==0 ? "L'aggiornamento è gratuito, procedere?" : `Attenzione per aggiornare questo report ti verranno scalati ${report.product.price} crediti`} buttonAction={() => updateReport(report.id)} action_text={<Trans>reports.actions.update</Trans>}/>				
			      </Badge>}				
		      </CardTitle>
		      <Collapse isOpen={isOpen} className="print">
			      <CardBody>
			        <Row>
				        <Col sm="6" >
				          <Card>
					          <CardBody className="py-4 card-more">
					            <Media>
						            <div className="d-inline-block mt-2 mr-3">
						              <Activity />
						            </div>
						            <Media body>
						              <h3 className="mb-2">{find_evaluation({score: report.final_more_score}).letter}</h3>
						              <div className="mb-0">Score</div>
						            </Media>
					            </Media>
					          </CardBody>
				          </Card>
				        </Col>
				        <Col sm="6" >
				          <Card>
					          <CardBody className="py-4 card-cl">
					            <Media>
						            <div className="d-inline-block mt-2 mr-3">
						              <i className="fa fa-money-bill"></i>
						            </div>
						            <Media body>
						              <h3 className="mb-2"><Trans values={{value: report.credit_limit}}>standard_formatting.currency</Trans></h3>
						              <div className="mb-0">Esposizione consigliata</div>
						            </Media>
					            </Media>
					          </CardBody>
				          </Card>
				        </Col>
			        </Row>

			        
			        
			        <Card>
				        <CardBody>
				          <CardTitle><Trans>reports.sections.negativity</Trans></CardTitle>
				          {report.black_record_details != null && (report.black_record_details.dishonored_bills.length > 0 || report.black_record_details.bankruptcy_liquidation_proceedings.length > 0) && 
				           <React.Fragment>
					           <h6>dishonored_bills</h6>
					           <StdTable collection={report.black_record_details.dishonored_bills} fields={['amount', 'effect_type', 'amount_currency', 'effect_type_code', 'non_payment_code', 'registration_date', 'non_payment_description']} collection_key="amount" />
					           <h6>bankruptcy_liquidation_proceedings</h6>
					           <StdTable collection={report.black_record_details.bankruptcy_liquidation_proceedings.map((bd) => {
					             bd.notes = (Array.isArray(bd.notes) ? bd.notes.map((c) => c).join('; ') : '-')
					             return bd
					           })} fields={['tribunal', 'event_code', 'closing_date', 'judgment_number', 'liquidation_date', 'event_description', 'notes']} collection_key="liquidation_date" />
				           </React.Fragment> }

				          {report.black_record_details == null && <h5>Non ci sono informazioni sulle negatività</h5> }
				          {report.black_record_details != null && (report.black_record_details.dishonored_bills.length == 0 && report.black_record_details.bankruptcy_liquidation_proceedings.length == 0) && <h5>Non ci sono negatività</h5> }
				          
				        </CardBody>
			        </Card>
			        
			        {
				        Array.isArray(report.accounts) && report.accounts.length > 0 ? 
											                                                     <React.Fragment>
											                                                       { report.accounts.filter(a => a.financial_data).length > 0 &&
												                                                       <Card>
												                                                         <CardBody>
													                                                         <CardTitle><Trans>reports.sections.balances</Trans></CardTitle>
													                                                         <Accounts accounts={report.accounts} />
												                                                         </CardBody>
												                                                       </Card>
											                                                       }
											                                                       <Card>
												                                                       <CardBody>
												                                                         <CardTitle><Trans>reports.sections.assessment</Trans></CardTitle>
												                                                         <Assesments accounts={report.accounts} report_type={report.product.name == 'SPEEK_FLASH' ? 'reduced' : 'complete'} />
												                                                         
												                                                       </CardBody>
											                                                       </Card>
											                                                     </React.Fragment>
									                                         :
											                                                     <Card>
											                                                       <CardBody>
												                                                       <CardTitle><Trans>reports.sections.balances</Trans></CardTitle>
												                                                       <h5>Non sono presenti bilanci</h5>
											                                                       </CardBody>
											                                                     </Card>						   
			        }
			        
			        
			        <Card>
				        <CardBody>
				          <CardTitle><Trans>reports.sections.board_of_directors</Trans></CardTitle>
				          {
					          Array.isArray(report.board_of_directors) && report.board_of_directors.length > 0 ?
														                                                                       
														                                                                       <StdTable trans_prefix="board_of_directors" collection={report.board_of_directors.map((bd) => {
															                                                                       bd.charges = (Array.isArray(bd.charges) ? bd.charges.map((c) => c.charge).join(', ') : '-')
															                                                                       
															                                                                       return {...bd, ...{name: `${bd.name} ${bd.surname ? bd.surname : ''}`}}
														                                                                       }  )} fields={['name',  'charges']} collection_key="name" />
					          
												                                                    :
														                                                                       <h5>Non sono presenti informazioni sul board</h5>
				          }
				        </CardBody>
			        </Card>
			        
			        <Card>
				        <CardBody>
				          <CardTitle><Trans>reports.sections.shareholders</Trans></CardTitle>
				          {
					          Array.isArray(report.shareholders) && report.shareholders.length > 0 ?
													                                                             <StdTable collection={report.shareholders.map(toSemaphore)} fields={['name', 'fiscal_code', 'semaphore', {name: 'percentage_share', type: 'percentage_100'}]} trans_prefix="shareholders" collection_key="fiscal_code" />
											                                               :
													                                                             <h5>Non sono presenti informazioni sui azionisti</h5>
					          
				          }
				        </CardBody>
			        </Card>
			      </CardBody>
		      </Collapse>
		    </Card>
	    )
	  else
	    return <div></div>
  }
}
export default Report
